import './../assets/css/style.css';
import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ImgBanner } from "./banner";
import { BoxTitle } from "./box";
import { Section } from "./section";
import { TitleMarca } from "./Text";
import { useState, useEffect } from 'react';
import BannerBottomBlack from './banners_bottomBlack';
import BannerBottomCyber from './banners_bottomCyber';
import BannerBottomProrrogado from './banners_bottomProrrogado';

function BannerBottom() {
    const [conteudo, setConteudo] = useState(<BannerBottomBlack />);
    const dataBlackFriday = new Date('2025-11-28T23:59:59');
    const dataProrrogado = new Date('2025-11-30T00:00:00');
    const dataCyber = new Date('2025-12-01T00:00:00');

    useEffect(() => {
        const verificarData = () => {
            const dataAtual = new Date();

            if (dataAtual >= dataProrrogado && dataAtual < dataCyber) {
                setConteudo(<BannerBottomProrrogado />);
            } else if (dataAtual > dataBlackFriday && dataAtual >= dataCyber) {
                setConteudo(<BannerBottomCyber />);
            }
        };
        verificarData();

        const intervalo = setInterval(verificarData, 60000);
        return () => clearInterval(intervalo);
    }, []);
    return (
        <Section className='c-banners-bottom'>
            {conteudo}
        </Section>

    )
}

export default BannerBottom;